const testStatusConstants = {
    EXECUTING: 'executing',
    FINISHED: 'finished',
    SCHEDULED: 'scheduled',
};

export default testStatusConstants;
